import { limit as limitFirebase, orderBy, where } from "firebase/firestore"
import { Collection, WhereField } from '../../shared/constants'
import { addDoc, deleteDoc, getAllDocsByQueries, getCountByQueries, updateDoc } from './collectionBaseWorker'

export const addQueue = async ({ data }) => {
    if (!data.status) {
        data.status = "in-queue"
    }
    data.createAt = new Date()
    if (!data.times) {
        data.times = 0
    }
    return await addDoc({ collection: Collection.CALLBACK_QUEUE, data: data })
}

export const getAllQueuesScheduledByGroup = async ({ group }) => {
    return await getAllDocsByQueries({
        collection: Collection.CALLBACK_QUEUE,
        queries: [
            where(WhereField.GROUP, "==", group),
            where(WhereField.STATUS, "==", "scheduled"),
        ]
    })
}

export const getAllQueuesScheduledByType = async ({ type }) => {
    return await getAllDocsByQueries({
        collection: Collection.CALLBACK_QUEUE,
        queries: [
            where(WhereField.TYPE, "==", type)
        ]
    })
}

export const getAllQueuesScheduledByGroupAndReferenceId = async ({ group, referenceId }) => {
    return await getAllDocsByQueries({
        collection: Collection.CALLBACK_QUEUE,
        queries: [
            where(WhereField.GROUP, "==", group),
            where("body.referenceId", "==", referenceId),
        ]
    })
}

export const getAllQueuesByDate = async ({ days }) => {
    const date = new Date()
    date.setDate(date.getDate() - days)
    return await getAllDocsByQueries({
        collection: Collection.CALLBACK_QUEUE,
        queries: [
            where(WhereField.CREATE_AT, ">=", date),
            orderBy(WhereField.CREATE_AT, "desc")
        ]
    })
}

export const getQuantityQueuesByDateAndStatus = async ({ days, status, future }) => {
    const date = new Date()
    if (future) {
        date.setDate(date.getDate() - days)
    } else {
        date.setDate(date.getDate() - days)
    }
    const quantity = await getCountByQueries({
        collection: Collection.CALLBACK_QUEUE,
        queries: [
            where(WhereField.CREATE_AT, ">=", date),
            where(WhereField.STATUS, "==", status),
            orderBy(WhereField.CREATE_AT, "desc"),
        ]
    })
    return quantity
}

export const getAllQueuesByDateAndStatus = async ({ days, status, limit }) => {
    const date = new Date()
    date.setDate(date.getDate() - days)
    return await getAllDocsByQueries({
        collection: Collection.CALLBACK_QUEUE,
        queries: [
            where(WhereField.CREATE_AT, ">=", date),
            where(WhereField.STATUS, "==", status),
            orderBy(WhereField.CREATE_AT, "desc"),
            limitFirebase(limit ?? 200)
        ]
    })
}

export const getAllQueuesByParkId = async ({ estacionamentoId, limit }) => {
    return await getAllDocsByQueries({
        collection: Collection.CALLBACK_QUEUE,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            orderBy(WhereField.CREATE_AT, "desc"),
            limitFirebase(limit ?? 500)
        ]
    })
}

export const getAllQueuesByTicketId = async ({ ticketId }) => {
    const items1 = await getAllDocsByQueries({
        collection: Collection.CALLBACK_QUEUE,
        queries: [
            where("body.ticketId", "==", ticketId),
            orderBy(WhereField.CREATE_AT, "desc"),
            limitFirebase(500)
        ]
    })
    const items2 = await getAllDocsByQueries({
        collection: Collection.CALLBACK_QUEUE,
        queries: [
            where("body.ids", "array-contains", ticketId),
            orderBy(WhereField.CREATE_AT, "desc"),
            limitFirebase(500)
        ]
    })
    items1.push(...items2)
    return items1.sort((a, b) => b.createdAt?.toDate() - a.createdAt?.toDate())
}

export const getAllQueuesByMonthlyId = async ({ monthlyId }) => {
    const items1 = await getAllDocsByQueries({
        collection: Collection.CALLBACK_QUEUE,
        queries: [
            where("body.monthlyId", "==", monthlyId),
            limitFirebase(500)
        ]
    })
    const items2 = await getAllDocsByQueries({
        collection: Collection.CALLBACK_QUEUE,
        queries: [
            where("body.ids", "array-contains", monthlyId),
            limitFirebase(500)
        ]
    })
    items1.push(...items2)
    return items1.sort((a, b) => b.createdAt?.toDate() - a.createdAt?.toDate())
}

export const deleteQueuesById = async ({ id }) => {
    await deleteDoc({ collection: Collection.CALLBACK_QUEUE, id: id })
}

export const updateQueueById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.CALLBACK_QUEUE, id: id, data: data })
}